import { Drawer } from '@mantine/core'
import { type ReactNode } from 'react'

import { burgerContent, burgerInner } from './styles.css'

interface BaseHeaderDrawerProps {
  opened: boolean
  onClose: () => void
  children: ReactNode
  position?: 'left' | 'right'
}

const BaseHeaderDrawer = ({ opened, onClose, children, position = 'left' }: BaseHeaderDrawerProps) => (
  <Drawer
    opened={opened}
    onClose={onClose}
    position={position}
    closeOnClickOutside
    padding="none"
    keepMounted
    overlayProps={{ backgroundOpacity: 0.8, blur: 0.9, color: 'black' }}
    closeButtonProps={{ size: 'xl' }}
    withCloseButton={false}
    classNames={{ body: burgerContent, inner: burgerInner }}
    styles={{
      content: { marginTop: '70px' },
      overlay: { marginTop: '70px' },
    }}
  >
    {children}
  </Drawer>
)

export const MobileMenuDrawer = BaseHeaderDrawer

export const DesktopMenuDrawer = ({ opened, onClose, children, position = 'right' }: BaseHeaderDrawerProps) => (
  <Drawer
    opened={opened}
    onClose={onClose}
    position={position}
    size="lg"
    closeOnClickOutside
    padding="none"
    keepMounted
    overlayProps={{ backgroundOpacity: 0.8, blur: 0.9, color: 'black' }}
    closeButtonProps={{ size: 'xl' }}
    withCloseButton={false}
    classNames={{ body: burgerContent, inner: burgerInner }}
    styles={{
      content: { marginTop: '70px' },
      overlay: { marginTop: '70px' },
    }}
  >
    {children}
  </Drawer>
)
